<template>
  <label :class="className + ' switch'">
    <input
      :checked="checkedRef"
      type="checkbox"
      @click="() => (checkedRef = !checkedRef)"
    />
    <span class="slider round" />
  </label>
</template>

<script setup lang="ts">
import { onMounted, ref, watch } from "vue";

const props = defineProps({
  checked: {
    type: Boolean,
    required: false,
  },
  className: {
    type: String,
    default: "",
  },
});

const emit = defineEmits(["update:checkbox"]);
const checkedRef = ref(props.checked);

onMounted(() => {
  checkedRef.value = props.checked;
});

watch(
  () => props.checked,
  (value) => {
    checkedRef.value = value;
  },
);

watch(
  () => checkedRef.value,
  (value) => {
    emit("update:checkbox", value);
  },
);
</script>

<style scoped lang="scss">
.switch {
  position: relative;
  display: inline-block;
  width: 49px;
  height: 28px;

  input {
    opacity: 0;
    width: 0;
    height: 0;
  }
}

.slider {
  position: absolute;
  cursor: pointer;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: #fff;
  -webkit-transition: 0.4s;
  transition: 0.4s;
  border: 1px solid #878787;
  box-shadow: none;

  &::before {
    position: absolute;
    content: "";
    height: 22px;
    width: 22px;
    left: 2px;
    bottom: 2px;
    background-color: #dbdbdb;
    -webkit-transition: 0.4s;
    transition: 0.4s;
  }
}

.grey-slider {
  .slider {
    background-color: #eff0f1;
    border: 1px solid #dbdbdb;
  }
  input:focus + .slider {
    box-shadow: none;
  }
}

input:checked + .slider {
  background-color: #387dff;
  border: 1px solid #387dff;
}

input:focus + .slider {
  box-shadow: 0 0 1px #387dff;
}

input:checked + .slider:before {
  -webkit-transform: translateX(20px);
  -ms-transform: translateX(20px);
  transform: translateX(20px);

  background-color: #fff;
}

/* Rounded sliders */
.slider.round {
  border-radius: 26px;
}

.slider.round:before {
  border-radius: 50%;
}
</style>
